import { z } from 'zod';

const ProdutoVariacaoValorSchema = z.object({
    pvv_empresa_idpk: z.number(),
    pvv_idpk: z.number(),
    pvv_produto_idpk: z.number(),
    pvv_produto_variacao_idpk: z.number().nullable(),
    pvv_valor: z.string(),
    pvv_variacao_idpk: z.number(),
});

export type ProdutoVariacaoVariacaoValor = z.infer<typeof ProdutoVariacaoValorSchema>;

const ProdutoVariacaoVariacaoSchema = z.object({
    pve_empresa_idpk: z.number(),
    pve_idpk: z.number(),
    pve_nome: z.string(),
    pve_produto_idpk: z.number(),
    pve_ultima_alteracao: z.string(),
    pve_variacao_idpk: z.number(),
    valor: ProdutoVariacaoValorSchema.array().nullable(),
});

export type ProdutoVariacaoVariacao = z.infer<typeof ProdutoVariacaoVariacaoSchema>;

const ProdutoVariacaoGradeSchema = z.object({
    estoque_total: z.number(),
    foto: z.string().nullable(),
    pro_cod_barra: z.string().nullable(),
    pro_codigo_interno: z.number(),
    pro_controlar_estoque: z.union([z.literal(1), z.literal(0)]).nullable(),
    pro_descricao: z.string(),
    pro_idpk: z.number(),
    pro_marcadores: z.string().nullable(),
    pro_preco_custo: z.number().nullable(),
    pro_preco_venda: z.number().nullable(),
    pro_sku: z.string().nullable(),
});

export const ProdutoVariacaoSchema = z.object({
    grade: ProdutoVariacaoGradeSchema.array().nullable(),
    variacao: ProdutoVariacaoVariacaoSchema.array().nullable(),
});
